import { Component } from 'react';
import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  /** Giao diện thay thế khi remote ném lỗi lúc render; `datLai` vẽ lại remote. */
  thayThe: (datLai: () => void) => ReactNode;
}

/**
 * Mỗi remote một ranh giới lỗi (G3-D3-3): module của bên thứ ba ném lỗi khi render chỉ làm
 * hỏng vùng của nó, thanh điều hướng và phần còn lại của cổng vẫn dùng được.
 */
export class RanhGioiLoiModule extends Component<Props, { coLoi: boolean }> {
  state = { coLoi: false };

  static getDerivedStateFromError(): { coLoi: boolean } {
    return { coLoi: true };
  }

  datLai = (): void => this.setState({ coLoi: false });

  render(): ReactNode {
    return this.state.coLoi ? this.props.thayThe(this.datLai) : this.props.children;
  }
}
